import { Link } from '@trashlab/sitesapp/src/components/shared/link';

export const KnowBeforeThrow = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-[#333333] mb-4 italic">
            Know Before You Throw...
          </h3>
          <p className="text-[#333333] mb-4">
            <strong>Due to the costs associated with disposing of different kinds of materials, RED-E-BINS pricing will depend on what you'll be getting rid of.</strong> Whenever possible, we recycle or donate items to reduce landfill use.
          </p>
          <Link
            href="/prohibited-items"
            className="text-[#E31837] hover:underline font-semibold"
          >
            What You Can't Put in a RED-E-BIN Dumpster &gt;&gt;
          </Link>
        </div>
      </div>
    </section>
  );
};

